import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import 'intl-pluralrules';

export type TranslationText = {
  readonly text: string;
  readonly ns: TranslationNamespace;
} & Record<string, string>;

export enum TranslationNamespace {
  Translation = 'translation', // Default
}

export enum TranslationLocale {
  EN = 'en',
  US = 'en-US',
  ZH = 'zh',
  HK = 'zh-HK',
  CN = 'zh-CN',
  TW = 'zh-TW',
  JA = 'ja',
  JP = 'ja-JP',
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false, // DEV,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    compatibilityJSON: 'v4',
    // nonExplicitSupportedLngs: true, // support language variation
    ns: Object.values(TranslationNamespace),
    fallbackLng: 'en',
    // lng: 'en',
    detection: {
      // The order and from where user language should be detected
      order: ['localStorage', 'navigator'],

      // Keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',

      // Cache user language on
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // react is already safe from xss
    },
  })
  .catch((e) => console.warn(e));

export default i18n;
